import './ContactList.css';

import ContactCard from "../../Elements/ContactCard/ContactCard.jsx";
import PaginateControls from '../../Elements/PaginateControls/PaginateControls';

import { getFriendsList } from '../../../../../Services/Inbox.js';
import { useEffect, useState } from 'react';

import useDebounce from '../../../../../Hooks/useDebounce';
import DialogModal from '../../../../Modals/dialogModal';

const ContactList = (props) => {

    const [friendList, setFriendList] = useState([]);
    const [paginData, setPaginData] = useState({ current_page: 1, last_page: 1 });
    const [searchName, setSearchName] = useState("");
    const [showModal, setShowModal] = useState(false);


    const loadFriendList = async (num = null, name = null) => {
        let rsp = await getFriendsList({ page: num || paginData.current_page || 1, name: name || searchName });


        if (rsp?.Error === false) {
            setFriendList(rsp.Data.data);
            setPaginData({ current_page: rsp.Data.current_page, last_page: rsp.Data.last_page });
            props.setIsLoading(false);
        } else {
            setShowModal(true)
        }
    }

    const handlePagin = (num) => {
        loadFriendList(paginData.current_page + num);
        setPaginData({ ...paginData, current_page: paginData.current_page + num });
    }

    const setOnSending = (id) => {
        props.setRigthBoxState({ type: 0, id: id })
    }

    const debounceLoadUserList = useDebounce(loadFriendList, 500);

    useEffect(() => {
        loadFriendList();
    }, []);

    return (
        <>
            <DialogModal showModal={showModal} setShowModal={setShowModal}>
                <h3>No se pudo cargar la informacion en este momento.</h3>
            </DialogModal>
            <div className='input-search-contact-div' style={{ paddingInline: "8px" }}>
                <label style={{ color: "white", marginInline: "4px", width: "30%" }}>Usuario</label>
                <input type="text" className='input-search-contact' placeholder='Buscar...' onChange={e => { setSearchName(e.target.value); debounceLoadUserList(1, e.target.value) }} />
            </div>

            <h3 style={{ textAlign: "center", margin: 10 }}>Contactos</h3>
            <h4 style={{ textAlign: "center", margin: 5 }}>Pagina {paginData.current_page} de {paginData.last_page}</h4>
            {
                friendList.map((item, index) => {
                    return (
                        <ContactCard user={item} key={index} buttonAction={{ title: "Enviar Mensaje", callback: setOnSending }} />
                    );
                })
            }
            <PaginateControls next={paginData.current_page < paginData.last_page} prev={paginData.current_page > 1} callback={handlePagin} />
        </>
    );
}

export default ContactList;